export interface CreditCardInfo {
  nameOnCard: string;
  cardNumber: string;
  expirationMonth: string;
  expirationYear: string;
  securityCode: string;
  cardProviderType: string;
}

export interface BillingInfo {
  country: string;
  streetAddress: string;
  city: string;
  state: string;
  zipCode: string;
}

export interface PaymentFormData {
  packs: PaymentPack[];
  creditCardInfo: CreditCardInfo;
  billingInfo: BillingInfo;
}

export enum PaymentStatus {
  Idle = "idle",
  Loading = "loading",
  Success = "success",
  Error = "error",
}

export interface PurchasePrice {
  subtotalAmount: number;
  taxAmount: number;
  totalAmount: number;
  packsPrices: { packId: number; subtotalAmount: number; taxAmount: number; totalAmount: number }[];
}

export interface PaymentPack {
  packName: string;
  packId: number;
  isExpired: boolean;
  isTrial: boolean;
  billingTerm: string;
  isPurchased: boolean;
  rawPricePerUser: number;
  licensesCount?: number;
  expirationDate?: Date;
  purchasingLicenses?: number;
}

export type ProcessPaymentHandler = (data: { formData: PaymentFormData; purchasePrice: PurchasePrice }) => void;
